import React, { useState } from 'react';
import { Form, Input, Button, Space, Modal } from 'antd';
import { useIntl, FormattedMessage } from 'react-intl';

const { Item } = Form;

interface Props {
  handleSubmit: (data: any) => void;
}

export interface FormValues {
  email: string;
}

const ForgotPasswordForm: React.FC<Props> = ({ handleSubmit }) => {
  const intl = useIntl();
  const [form] = Form.useForm<FormValues>();
  const [isEmailUpperCase, setIsEmailUpperCase] = useState(false);

  const handleModalCancel = () => {
    setIsEmailUpperCase(false);
  };

  const handleModalConfirm = () => {
    handleSubmit(form.getFieldsValue());
    form.resetFields();
    setIsEmailUpperCase(false);
  };

  return (
    <>
      <Form
        form={form}
        requiredMark={false}
        layout="vertical"
        onFinish={(values) => {
          handleSubmit(values);
          form.resetFields();
        }}
        css={`
          label {
            color: rgba(0, 0, 0, 0.45);
          }
          .ant-form-item-label {
            padding-bottom: 3px;
          }
        `}
      >
        <Space orientation="vertical" css="width: 100%" size="large">
          <Item
            name="email"
            label={intl.formatMessage({ defaultMessage: 'Email address' })}
            rules={[
              {
                required: true,
                message: intl.formatMessage({
                  defaultMessage: 'This field is required',
                }),
              },
              {
                type: 'email',
                message: intl.formatMessage({
                  defaultMessage: 'A valid email is required',
                }),
              },
            ]}
          >
            <Input
              type="email"
              size="large"
              css="min-width: 350px"
              onChange={() => {
                const { email } = form.getFieldsValue();
                if (email && email !== email.toLowerCase()) {
                  setIsEmailUpperCase(true);
                }
              }}
            />
          </Item>
          <Item>
            <Button type="primary" size="large" htmlType="submit" block>
              <FormattedMessage defaultMessage="Request new password" />
            </Button>
          </Item>
        </Space>
      </Form>
      <Modal
        open={isEmailUpperCase}
        onCancel={handleModalCancel}
        onOk={handleModalConfirm}
        okText={intl.formatMessage({ defaultMessage: 'Send' })}
        title={intl.formatMessage({
          defaultMessage: 'Is your Email address correct?',
        })}
      >
        <p>
          {intl.formatMessage({
            defaultMessage:
              'We detected uppercase letters. If the email address does not match our entry, your reset-link could not arrive. Do you want to proceed anyway?',
          })}
        </p>
      </Modal>
    </>
  );
};

export default ForgotPasswordForm;
